import type { ComponentProps } from "react";
import ReactCalendar from "react-calendar";
import "./index.scss";

type ReactCalendarProps = ComponentProps<typeof ReactCalendar>;

export function Calendar(props: ReactCalendarProps) {
  return <ReactCalendar calendarType="US" className="ReactCalendar" {...props} />;
}
